import { css, FlattenSimpleInterpolation } from 'styled-components';

const quickSalePortalScrollbar = (): FlattenSimpleInterpolation => {
  return css`
    /* Chrome and Safari*/
    &::-webkit-scrollbar {
      width: 8px;
      background-color: '#F5F5F5';
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
      border-bottom-right-radius: 7px;
      border-top-right-radius: 7px;
      background-color: '#F5F5F5';
    }

    &::-webkit-scrollbar-thumb {
      border-bottom-right-radius: 7px;
      border-top-right-radius: 7px;
      box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
      background-color: lightgray;
    }
    /* Firefox */
    & {
      scrollbar-color: lightgray #f5f5f5;
      scrollbar-width: thin;
    }
    /* Internet explorer 11 */
    & {
      scrollbar-face-color: lightgray;
      scrollbar-track-color: #f5f5f5;
      scrollbar-3dlight-color: #f5f5f5;
      scrollbar-highlight-color: #f5f5f5;
      scrollbar-darkshadow-color: #f5f5f5;
      scrollbar-shadow-color: #f5f5f5;
      scrollbar-arrow-color: lightgray;
    }
  `;
};

export default quickSalePortalScrollbar;
